import React, { useState, useEffect } from 'react';
import Label from 'components/v2/forms/Label';
import Select from 'components/v2/select';
import { useTranslation } from 'react-i18next';
import EditableSection from 'components/v2/EditableSection';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { checkPermissonForEditShipperBillingModule } from './utils';
const InvoicingSummary = ({ fields }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement(DescriptionListItem, { label: t('BLACK_AND_WHITE_QUESTION'), className: "" }, fields.black_and_white_invoices)));
};
const InvoicingForm = ({ fields, onChange, onSaveSuccess, onSaveFail, saving, onSaveShipper, }) => {
    const { t } = useTranslation();
    const options = [
        { value: 'Yes', name: 'Yes', localizationSlug: 'YES' },
        { value: 'No', name: 'No', localizationSlug: 'NO' },
    ];
    const saveForm = async () => {
        try {
            await onSaveShipper();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement("div", null,
            React.createElement(Label, { htmlFor: "black_white", className: "mb-1" }, t('BLACK_AND_WHITE_QUESTION')),
            React.createElement(Select, { items: options, valueKey: "value", textKey: "localizationSlug", selected: fields.black_and_white_invoices, onSelect: (option) => {
                    onChange('black_and_white_invoices', option === null || option === void 0 ? void 0 : option.value);
                } }))));
};
const Invoicing = ({ data, className, onUpdateShipper }) => {
    const { t } = useTranslation();
    const [initialData, setinitialData] = useState(data);
    const [invoiceSettingsData, setInvoiceSettingsData] = useState(data);
    const onChange = (field, value) => {
        setInvoiceSettingsData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const getInitData = () => {
        if (data) {
            if (data.black_and_white_invoices) {
                setInvoiceSettingsData({ black_and_white_invoices: 'Yes' });
                setinitialData({ black_and_white_invoices: 'Yes' });
            }
            else {
                setInvoiceSettingsData({ black_and_white_invoices: 'No' });
                setinitialData({ black_and_white_invoices: 'No' });
            }
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setinitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    const handleSave = async () => {
        const payload = {
            black_and_white_invoices: invoiceSettingsData.black_and_white_invoices === 'Yes',
        };
        if (!Object.keys(invoiceSettingsData).every((key) => initialData[key] === invoiceSettingsData[key])) {
            await onUpdateShipper(payload);
        }
    };
    useEffect(() => {
        getInitData();
    }, [data]);
    return (React.createElement(EditableSection, { className: className, title: t('INVOICE'), onSave: handleSave, canEdit: checkPermissonForEditShipperBillingModule() }, (editMode, saving, onSaveSuccess, onSaveFail) => editMode ? (React.createElement(InvoicingForm, { fields: invoiceSettingsData, saving: saving, onChange: onChange, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: () => onSaveFail(), onSaveShipper: () => handleSave() })) : (React.createElement(InvoicingSummary, { fields: initialData }))));
};
export default Invoicing;
